module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_06.png?9d2be736c0b4d72f827afdfed7fb807b";